import { Injectable } from '@angular/core';
import { UserContactUs } from '../../models/Auth';
import { CrewbidApiService } from '../../services/crewbid-api.service';

@Injectable({
  providedIn: 'root',
})
export class HelpMenuService {
  constructor(private ApiService: CrewbidApiService) {}

  /**
   * @method GetUserById To get user details
   * @param userId is employee number as string
   */
  public GetUserById(userId: string) {
    try {
      return this.ApiService.GetRestDataForGet(
        'user/GetUsersById?id=' + userId
      );
    } catch (error) {
      console.log(error.stack.toString());
    }
  }

  /**
   * @method SendMailToAdmin for sending the mail
   * @param user is employee details as UserContactUs
   */
  public SendMailToAdmin(user: UserContactUs) {
    try {
      return this.ApiService.GetRestDataForPost(
        'user/SendContactUsMail/',
        user
      );
    } catch (error) {
      console.log(error.stack.toString());
    }
  }
  /**
 * @method LogOffLineEvents To add log for bid download timeout.
 */
  public LogOffLineEvents(offLineEvent: any) {
    try {
      return this.ApiService.GetRestDataForPost(
        "User/LogOffLineEvents",
        offLineEvent
      );
    } catch (error) {
      throw `Function Name: LogOffLineEvents', Error:  ${error.stack.toString()}`;
    }
  }
}
